import * as React from "react";
import CorporateLogo from "../atoms/corporate-logo";
import { useSearchParams } from "next/navigation";
import { Footer } from "@graffer-inc/graffer-design-kit";
import { footerLinkInfos } from "../../consts/fotter-link";
import { useName } from "@/component/hooks/use-name";

type Props = {
  title?: string;
  children: React.ReactNode;
};

export const UnauthLayout: React.FC<Props> = (props) => {
  const search = useSearchParams();
  const name = useName(search);
  // TODO インターフェースとして実装するものの、まだ値を利用することはないのでコメントアウトしておく
  // const redirectParams = parseQueryOf(location.search).redirectParams as string;
  // const slug = parseQueryOf(location.search).slug as string;

  return (
    <div className="App">
      <div className="hero is-fullheight">
        <div
          className="container"
          style={{ paddingTop: "1.5rem", maxWidth: "640px" }}
        >
          <div className="columns mx-0">
            <div className="column">
              <header className="has-text-centered mb-5">
                <CorporateLogo />
                <p
                  className="title is-size-5 has-text-centered"
                  data-testid="name"
                >
                  {name}
                </p>
              </header>
              <main>{props.children}</main>
            </div>
          </div>
        </div>
      </div>
      <Footer
        companyLabel="株式会社グラファーが運営しています。"
        linkInfos={footerLinkInfos}
      />
    </div>
  );
};
